export const TELEMEDICINE_INFO = {
	code: '127304670',
	name: 'Teleconsulta - Digital',
	label: 'Atendimento por vídeo chamada',
	cityName: 'FORTALEZA',
	ufCode: 'CE',
	ufName: 'CEARA',
};
